import { computed } from 'vue';
import { useStoreCountry } from '~/stores/client/country';

export const useTextReplacements = () => {
  const isPlayerFromAustraliaOrNewZeland = computed(
    () => storeCountry.country === 'AU' || storeCountry.country === 'NZ'
  );

  const storeCountry = useStoreCountry();

  const replaceSlotsToPokies = (text: string) => {
    return text.replace('Slots', 'Pokies').replace('slots', 'pokies');
  };

  const replaceSlotsToPokiesIfNeeded = (text: string) => {
    return !isPlayerFromAustraliaOrNewZeland.value ? text : replaceSlotsToPokies(text);
  };

  return {
    replaceSlotsToPokiesIfNeeded,
  };
};
